import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './SeasonsFilter.module.css';
import AutumnImage from 'assets/images/fall.png';
import SpringImage from 'assets/images/spring.png';
import SummerImage from 'assets/images/summer.png';
import WinterImage from 'assets/images/winter.png';

const seasonsFilter = (props) => {
  const containerClasses = [classes.Container];
  if (props.show) containerClasses.push(classes.Open);
  return (
    <div className={containerClasses.join(' ')}>
      <div className={classes.Seasons}>
        <div
          className={props.seasons.includes('Spring') ? [classes.Season, classes.Selected].join(' ') : classes.Season}
          onClick={() => props.select(['Spring'], 'seasons')}
        >
          <div className={classes.FilterSelected}>
            <FontAwesomeIcon icon="check" className={classes.CheckMark} />
          </div>
          <img src={SpringImage} alt="Spring" />
          <p>Spring</p>
        </div>
        <div
          className={props.seasons.includes('Summer') ? [classes.Season, classes.Selected].join(' ') : classes.Season}
          onClick={() => props.select(['Summer'], 'seasons')}
        >
          <div className={classes.FilterSelected}>
            <FontAwesomeIcon icon="check" className={classes.CheckMark} />
          </div>
          <img src={SummerImage} alt="Summer" />
          <p>Summer</p>
        </div>
        <div
          className={props.seasons.includes('Fall') ? [classes.Season, classes.Selected].join(' ') : classes.Season}
          onClick={() => props.select(['Fall'], 'seasons')}
        >
          <div className={classes.FilterSelected}>
            <FontAwesomeIcon icon="check" className={classes.CheckMark} />
          </div>
          <img src={AutumnImage} alt="Autumn" />
          <p>Autumn</p>
        </div>
        <div
          className={props.seasons.includes('Winter') ? [classes.Season, classes.Selected].join(' ') : classes.Season}
          onClick={() => props.select(['Winter'], 'seasons')}
        >
          <div className={classes.FilterSelected}>
            <FontAwesomeIcon icon="check" className={classes.CheckMark} />
          </div>
          <img src={WinterImage} alt="Winter" />
          <p>Winter</p>
        </div>
      </div>
      <div className={classes.Controls}>
        <p onClick={props.clear}>Clear</p>
        <p onClick={props.submit}>SAVE</p>
      </div>
    </div>
  );
};

export default seasonsFilter;
